import React, { useState } from "react";

import {
    createUser
} from "../../api/UserApi";
import CustomSelect from "../shared/CustomSelect";
import { toast } from "../shared/Toast";


const AddUserModal = ({
    close,
    refresh
}) => {


    const [loading, setLoading] = useState(false);


    const [form, setForm] = useState({

        name: "",
        email: "",
        password: "",
        role: "admin"

    });



    const handleChange = (e) => {

        setForm({

            ...form,

            [e.target.name]: e.target.value

        });

    };



    const handleSubmit = async (e) => {

        e.preventDefault();


        try {


            setLoading(true);


            await createUser(form);


            toast.success("User created successfully");


            refresh();

            close();


        }
        catch (error) {

            console.log(error);

            toast.error(error.response?.data?.message || "Unable to create user");

        }
        finally {

            setLoading(false);

        }


    };



    return (

        <div style={overlay}>


            <form

                onSubmit={handleSubmit}

                style={modal}

            >


                <h2>
                    Add User
                </h2>



                <label>
                    Name
                </label>


                <input

                    name="name"

                    value={form.name}

                    onChange={handleChange}

                    style={input}

                    required

                />




                <label>
                    Email
                </label>


                <input

                    type="email"

                    name="email"

                    value={form.email}

                    onChange={handleChange}

                    style={input}

                    required

                />




                <label>
                    Password
                </label>


                <input

                    type="password"

                    name="password"

                    value={form.password}

                    onChange={handleChange}

                    style={input}

                    required

                />





                <label style={{ fontSize: '13px', fontWeight: 500, color: '#374151', display: 'block', marginBottom: '6px' }}>
                    Role
                </label>

                <div style={{ marginBottom: '15px' }}>
                    <CustomSelect
                        options={[
                            { value: "admin", label: "Admin" },
                            { value: "finance", label: "Finance" },
                            { value: "auditor", label: "Auditor" }
                        ]}
                        value={form.role}
                        onChange={(val) => setForm(prev => ({ ...prev, role: val }))}
                        placeholder="Select Role"
                    />
                </div>




                <div

                    style={buttonBox}

                >


                    <button

                        type="button"

                        onClick={close}

                        style={cancel}

                    >

                        Cancel

                    </button>



                    <button

                        disabled={loading}

                        type="submit"

                        style={save}

                    >

                        {
                            loading
                                ?
                                "Saving..."
                                :
                                "Save"
                        }

                    </button>


                </div>



            </form>


        </div>

    )

}



const overlay = {

    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000

};



const modal = {

    background: "#fff",
    width: 450,
    padding: 30,
    borderRadius: 10

};



const input = {

    width: "100%",
    padding: "10px 14px",
    margin: "8px 0 15px",
    border: "1px solid #E5E7EB",
    borderRadius: 8,
    fontSize: "14px",
    outline: "none",
    boxSizing: "border-box"

};



const buttonBox = {

    display: "flex",
    justifyContent: "flex-end",
    gap: 15

};



const save = {

    background: "#20B967",
    color: "#fff",
    border: "none",
    padding: "10px 25px",
    borderRadius: 6,
    cursor: "pointer"

};



const cancel = {

    background: "#ddd",
    border: "none",
    padding: "10px 25px",
    borderRadius: 6,
    cursor: "pointer"

};



export default AddUserModal;